
import {computed, defineComponent, inject, ref} from 'vue';
import SequenceId from '@/utils/sequence-id';
import {useI18n} from 'vue-i18n';
import {useStore} from '@/store';
import {supportTypes} from '@/image-processor';
import {key as keyToast} from '@/toast';
import {Modal} from 'bootstrap';
export default defineComponent({
  setup() {
    const {t} = useI18n({useScope: 'global'});
    const store = useStore();

    const componentID = SequenceId.getNew();
    const busy = ref<boolean>(false);
    const modalStatus = ref<HTMLElement | null>(null);

    const showToast = inject(keyToast);

    const selectedType = computed({
      get: () => store.state.type,
      set: value => store.dispatch('setType', value),
    });

    const quality = computed({
      get: () => store.state.quality,
      set: value => store.dispatch('setQuality', value),
    });

    const nameTransformPattern = computed({
      get: () => store.state.nameTransformPattern,
      set: value => store.dispatch('setNameTransformPattern', value),
    });

    const disabledDownload = computed(() => store.state.fileList.length === 0);

    const downloadAll = async (method = 'common') => {
      if (!showToast) throw new Error('Toasts not injected in the component!');
      showToast({
        text: t('download.toast.createzip.text'),
        type: 'info',
        title: '',
        duration: 3000,
      });
      const element = modalStatus.value;
      if (!element)
        throw new Error('Template problem: Modal HTMLElement is undefined');

      const myModal = new Modal(element, {
        keyboard: false,
      });
      try {
        myModal.show();
        await store.dispatch('downloadAll', method);
        showToast({
          text: t('download.toast.successzip.text'),
          type: 'success',
          title: '',
          duration: 3000,
        });
      } catch (error) {
        console.warn(error);
        showToast({
          text: t('download.toast.errorzip.text'),
          type: 'danger',
          title: '',
          duration: 3000,
        });
      } finally {
        setTimeout(() => myModal.hide(), 1500);
      }
    };

    return {
      t,
      supportTypes,
      selectedType,
      componentID,
      busy,
      quality,
      nameTransformPattern,
      disabledDownload,
      downloadAll,
      modalStatus,
    };
  },
});
